var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"900","persistent":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text d-flex justify-space-between py-3"},[_c('v-icon',{staticClass:"white--text",on:{"click":() => {
            _vm.$emit('close');
          }}},[_vm._v(_vm._s(_vm.$t("ic.close"))+" ")])],1),_c('v-card-text',{staticClass:"reportTblByMajor elevation-2 py-2 pt-5"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }